module.exports = __webpack_public_path__ + "static/img/1.718f741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slwh/1.png
// module id = nk+y
// module chunks = 0